import { Component, OnInit, Input, Output, EventEmitter, Inject, OnDestroy, AfterViewInit } from '@angular/core';

import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { DataInput, TrivUIToolsLibModule }  from '@trivelope/triv-ui-tools-lib';

import { Member, MemberSectionLink } from 'src/app/classes/member';
import { MemberService } from 'src/app/services/member.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Section } from 'src/app/classes/section';
import { Environment } from 'src/app/classes/environment';
import { Group, MemberGroup } from 'src/app/classes/fileInfo';
import { FileService } from 'src/app/services/file.service';
import { debounceTime, distinctUntilChanged, filter, forkJoin, map, Observable, of, Subscription, switchMap, tap } from 'rxjs';
import { CategoryService } from 'src/app/services/news-category.service';
import { DocumentExchangeCategory } from 'src/app/classes/document-exchange';
import { DocumentExchangeService } from 'src/app/services/document-exchange.service';
import { User } from 'src/app/classes/user';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { UserService } from 'src/app/services/user.service';
import { RouterModule } from '@angular/router';


@Component({
	selector: 'app-member-editor',
	templateUrl: './member-editor.component.html',
	styleUrls: [ './editor.component.css' ],
	standalone: true,
	imports: [
		TrivUIToolsLibModule,
		FormsModule, ReactiveFormsModule, MatInputModule,
		MatButtonModule,
		MatOptionModule, MatFormFieldModule, MatCheckboxModule, MatSelectModule,
		MatIconModule,
		RouterModule
	]
})
export class MemberEditorComponent implements OnInit, OnDestroy {


	private _member: Member = new Member();
	@Input() set member( val: Member ) {
		this._member = val;
		this.updateValueForm();
	}
	get member() { return this._member; }

	formG1: FormGroup<{ [key: string]: FormControl<string|number|boolean> }> = new FormGroup({});
	formSections: FormGroup<{ [key: string]: FormControl<boolean|null> }> = new FormGroup({});
	formDateiGruppen = new FormGroup({});
	formDEC = new FormGroup({});
	formReadonly: FormGroup<{ [key: string]: FormControl<string> }> = new FormGroup({});
	myInputs: { [key: string]: DataInput } = {};
	categoryInputs: DataInput[] = [];

	@Output() done = new EventEmitter<Member>();

	bAdmin = false;
  bHasRole = false;

	private _sections: Section[] = [];
	@Input() set sections( val: Section[] ) {
		this._sections = val;
		this.initSections();
		this.updateValueForm();
	}
	get sections() { return this._sections; }

	msLinks: MemberSectionLink[] = [];

	@Input() groups: Group[] = [];
	memberGroupsLinked: MemberGroup[] = [];

	bSaveInProgress = false;

	private _documentExchangeCategories: DocumentExchangeCategory[] = [];
	@Input() set documentExchangeCategories( val: DocumentExchangeCategory[] ) {
		this._documentExchangeCategories = val;
		this.initDocumentExchangeCategories();
		this.updateValueForm();
	}
	get documentExchangeCategories() { return this._documentExchangeCategories; }
	decLinked: DocumentExchangeCategory[] = [];

	mainContactCtrl = new FormControl( "" );
	@Input() users: User[] = [];
	@Input() usernames: { [key:string]: string } = {};

	subscriptions = new Subscription();


	constructor(
		private memberService: MemberService,
		private authService: AuthenticationService,
		private fileService: FileService,
		@Inject('environment') public environment: Environment,
		private categoryService: CategoryService,
		private documentExchangeService: DocumentExchangeService,
		private userService: UserService
	) {

		const categories = this.categoryService.getCategoriesInCache();
		console.log( "categories cache", categories )
		for( const category of categories ) {
			const di = new DataInput();
			di.label = category.bezeichnung;
			di.type = "check";
			di.id = "category_" + category.kategorieId;
			this.categoryInputs.push( di );
		}

		for( let dataInput of this.environment.member ) {
			this.myInputs[ dataInput.id ] = dataInput;
		}

	}


	ngOnInit() {

		console.log( 'MEMBER-EDITOR.component ngOnInit()', this._member.mitgliedId, this.myInputs, this.myInputs.mitgliedsname )
		this.bAdmin = this.authService.isAdmin();
    this.bHasRole = this.authService.hasRole();

		this.initSections();
		this.initDocumentExchangeCategories();

		if( this.groups.length && this.bAdmin ) {

			for( const g of this.groups ) {
				this.formDateiGruppen.addControl( g.gruppenId, new UntypedFormControl( false ) );
			}

			setTimeout( () => {
				if( this._member.mitgliedId ) {

					this.fileService.getMemberGroups( this._member.mitgliedId ).subscribe( mgs => {

						this.memberGroupsLinked = mgs;
						for( const mg of mgs ) {
							this.formDateiGruppen.get( mg.gruppenId )?.setValue( true );
						}

						this.subscriptions.add(
							this.formDateiGruppen.valueChanges.pipe(
								distinctUntilChanged(),
								switchMap( v => this.saveDateiGruppen() )
							).subscribe()
						);

					});

				}
			}, 1 );

		}

		this.subscriptions.add(
			this.mainContactCtrl.valueChanges.pipe(
				debounceTime( 400 ),
				distinctUntilChanged(),
				switchMap( ebeId => {

					const user = this.users.find( u => u.ebeId == ebeId );
					if( !user ) {
						console.error( "USER NOT FOUND", ebeId , this.users );
						return of(false);
					}
					this.formReadonly.get( "mainContactName" )?.patchValue( this.usernames[ ebeId || '' ], { emitEvent: false } );
					this.formReadonly.get( "mainContactPhone" )?.patchValue( user.ebeTelefon, { emitEvent: false } );
					this.formReadonly.get( "mainContactEmail" )?.patchValue( user.ebeMail, { emitEvent: false } );

					if( !ebeId ) return of(true);

					// autosave only if Member edition
					if( this._member.mitgliedId ) {
						return this.saveMainContact();
					}
					else {
						return of(true);
					}

				} )
			).subscribe()
		);

		this.mainContactCtrl.disable( { emitEvent: false } );


		setTimeout( () => {

			if( this.bAdmin ) {
				this.formG1.enable();
				this.formDEC.enable();
			}

			if(this.bHasRole)  {
				this.formG1.enable();
				this.formG1.get( 'mitgliedsnummer' )?.disable();
				this.formG1.get( 'mitgliedsname' )?.disable();
			}

			this.formG1.get( "mainContactName" )?.disable();
			this.formG1.get( "mainContactPhone" )?.disable();
			this.formG1.get( "mainContactEmail" )?.disable();

			this.updateValueForm();

			this.subscriptions.add(
				this.formG1.valueChanges.pipe(
					debounceTime( 400 ),
					distinctUntilChanged(),
					filter( v => !!this._member.mitgliedId ),	// autosave only if Member edition
					filter( () => this.formG1.valid ),	// respect required fields while autosaving
					switchMap( v => {
						return this.saveMemberObject();
					} )
				).subscribe()
			);

		}, 1 );

	}

	private initSections() {

		if( !this._sections || !this._sections.length ) return;
		if( !this.bAdmin ) return;
		if( !this.environment.features.sparten ) return;

		let nControls = 0;
		for( const property in this.formSections.controls ) {
			console.log( "nControls", nControls )
			if( this.formSections.controls.hasOwnProperty(property) ) {
				nControls++;
			}
		}
		if( nControls == this.sections.length ) return;

		for( const s of this._sections ) {
			const c = new FormControl<boolean>( false );
			c.disable();
			this.formSections.addControl( s.sparteId, c );
		}

		this.subscriptions.add(
			this.formSections.valueChanges.pipe(
				distinctUntilChanged(),
				filter( v => !!this._member.mitgliedId ),	// autosave only if Member edition
				switchMap( v => this.saveMemberSectionLinks() )
			).subscribe()
		);

	}

	private initDocumentExchangeCategories() {

		if( !this._documentExchangeCategories || !this._documentExchangeCategories.length ) return;
		if( !this.bAdmin ) return;

		let nControls = 0;
		for( const property in this.formDEC.controls ) {
			console.log( "nControls", nControls )
			if( this.formDEC.controls.hasOwnProperty(property) ) {
				nControls++;
			}
		}
		if( nControls == this._documentExchangeCategories.length ) return;

		for( const dec of this._documentExchangeCategories ) {
			const c = new FormControl( false );
			c.disable();
			this.formDEC.addControl( dec.id, c );
		}

	}

	private updateValueForm() {

		this.formG1.reset();

		this.formG1.patchValue( {
			mitgliedsname: this._member.mitgliedsname,
			mitgliedsnummer: this._member.mitgliedsnummer,
			gsStrasse: this._member.gsStrasse,
			gsOrt: this._member.gsOrt,
			gsPLZ: this._member.gsPLZ,
			gsTelefon: this._member.gsTelefon,
			gsFax: this._member.gsFax,
			gsWebAdesse: this._member.gsWebAdesse,
			gsEmail: this._member.gsEmail,
		} );

		this.mainContactCtrl.patchValue( this._member.hauptansprechpartnerId, { emitEvent: false } );
		if( this.users ) {
			const user = this.users.find( u => u.ebeId == this._member.hauptansprechpartnerId );
			if( user ) {
				this.formReadonly.get( "mainContactName" )?.patchValue( this.usernames[ user.ebeId ] );
				this.formReadonly.get( "mainContactPhone" )?.patchValue( user.ebeTelefon );
				this.formReadonly.get( "mainContactEmail" )?.patchValue( user.ebeMail );
			}
		}

		// opposite because the label says: "Public data?"
		this.formG1.get( "privateDaten" )?.patchValue( !this._member.privateDaten, { emitEvent: false } );

		if( this._member.kategorieIds && this._member.kategorieIds.length ) {
			for( const categoryId of this._member.kategorieIds ) {
				this.formG1.get( "category_" + categoryId )?.patchValue( true, { emitEvent: false } );
			}
		}

		if( this.bAdmin ) {

			if( this._member && this._member.mitgliedId ) {

				const obss = [ of(true) ];

				if( this.environment.features.sparten && !this.msLinks.length ) {
					obss.push( this.memberService.getSectionsOfMember( this._member.mitgliedId ).pipe(
						map( msLinks => {

							this.msLinks = msLinks;

							if( !this.sections.length ) return true;
							for( const s of this.sections ) {

								const c = this.formSections.get( s.sparteId );
								if( !c ) continue;
								c.enable( { emitEvent: false } );

								if( this.msLinks.find( msl => msl.sparteId === s.sparteId ) ) {
									c.patchValue( true, { emitEvent: false } );
								}
								else {
									c.patchValue( false, { emitEvent: false } );
								}
							}

							return true;

						})
					) );
				}

				if( this.environment.features.austausch && !this.decLinked.length ) {
					obss.push( this.documentExchangeService.getDocumentExchangeCategoriesOfMember( this._member.mitgliedId ).pipe(
						map( categories => {

							if( !categories ) return false;

							this.decLinked = categories;

							if( !this.documentExchangeCategories.length ) return true;
							for( const categ of this.documentExchangeCategories ) {

								const c = this.formDEC.get( categ.id );
								if( !c ) continue;
								c.enable();

								if( this.decLinked.find( categLinked => categLinked.id === categ.id ) ) {
									c.patchValue( true, { emitEvent: false } );
								}
								else {
									c.patchValue( false, { emitEvent: false } );
								}
							}

							return true;
						})
					) );
				}

				forkJoin(obss).subscribe(() => {

					this.subscriptions.add(
						this.formDEC.valueChanges.pipe(
							distinctUntilChanged(),
							filter(v => !!this._member.mitgliedId),
							switchMap(() => this.saveMemberDocumentExchangeCategoryLinks())
						).subscribe()
					);

				});

			}
			else {

				this.formSections.enable( { emitEvent: false } );

			}

		}

	}

	cancel() {
		this.done.emit( new Member() );
	}

	reset() {
		this.updateValueForm();
	}

	createMember() {

		console.clear();
		console.warn( "SAVE" )

		this.bSaveInProgress = true;
		this.mainContactCtrl.disable( { emitEvent: false });

		this.saveMemberObject().pipe(
			switchMap( memberSaved => {

				if( !memberSaved || !memberSaved.mitgliedId ) {
					this.bSaveInProgress = false;
					this.mainContactCtrl.disable( { emitEvent: false });
					return of(null);
				}

				const obss: Observable<boolean>[] = [
					this.saveDateiGruppen()
				];

				if( this.environment.features.sparten ) {
					obss.push( this.saveMemberSectionLinks() );
				}

				if( this.environment.features.austausch ) {
					obss.push( this.saveMemberDocumentExchangeCategoryLinks() );
				}

				const mainContact = this.mainContactCtrl.value || "";
				if( mainContact ) {
					const user = this.users.find( u => u.ebeId == mainContact );
					if( user ) {
						obss.push(
							this.userService.updateUser( { ...user, mitgliedId: memberSaved.mitgliedId } ).pipe(
								switchMap( userSaved => {
									if( !userSaved || (typeof(userSaved) == "number") || !userSaved.ebeId ) return of(false);
									return this.memberService.setMitgliedMainContact(
										mainContact,
										memberSaved.mitgliedId,
									);
								} )
							)
						)
					}
				}

				return forkJoin( obss );

			})
		).subscribe( results => {

			this.bSaveInProgress = false;
			this.mainContactCtrl.disable( { emitEvent: false });

			if( results ) {

				for( const b of results ) {
					if( !b ) return;
				}
				this.done.emit( this._member );

			}

		});

	}

	private saveMemberSectionLinks(): Observable<boolean> {

		this.bSaveInProgress = true;
		const sections = this.formSections.value;
		this.formSections.disable( { emitEvent: false } );

		const linksToDelete: MemberSectionLink[] = [];
		for( const msLink of this.msLinks ) {
			if( !sections[ msLink.sparteId ] ) {
				msLink.unassign = true;
				linksToDelete.push(msLink);
			}
		}

		const obss = [ of(true) ];

		if( linksToDelete.length ) {
			obss.push( this.memberService.updateMemberSectionLinks( linksToDelete ).pipe(
				map( r => {
					this.msLinks = this.msLinks.filter( l => !linksToDelete.includes(l) )
					return true;
				})
			) );
		}

		const obssToCreate: Observable<MemberSectionLink>[] = [];
		for( const sparteId in sections ) {

			if( !sections.hasOwnProperty(sparteId) ) continue;
			if( !sections[sparteId] ) continue;
			if( this.msLinks.find( msl => msl.sparteId == sparteId ) ) continue;

			const msl = new MemberSectionLink();
			msl.mitgliedId = this._member.mitgliedId;
			msl.sparteId = sparteId;
			obssToCreate.push( this.memberService.createMemberSectionLink( msl ).pipe(
				tap( mslSaved => {
					if( mslSaved.msId ) {
						this.msLinks.push( mslSaved );
					}
				} )
			) );

		}
		if( obssToCreate.length ) {
			obss.push( forkJoin( obssToCreate ).pipe(
				map( msls => {
					for( const msl of msls ) {
						if( !msl || !msl.msId ) return false;
					}
					return true;
				})
			) );
		}

		return forkJoin( obss ).pipe(
			map( results => {
				this.bSaveInProgress = false;
				this.formSections.enable( { emitEvent: false } );

				for( const b of results ) {
					if( !b ) return false;
				}
				return true;
			})
		);


	}

	private saveMemberDocumentExchangeCategoryLinks(): Observable<boolean> {

		const formValue = this.formDEC.value as { [key:string]: boolean | null };

		const hasChanged = this._documentExchangeCategories.some(dec => {
			const formVal = !!formValue[dec.id];
			const isLinked = !!this.decLinked.find(c => c.id === dec.id);
			return formVal !== isLinked;
		});

		if (!hasChanged) return of(true);

		const obss = [ of(true) ];

		const obssToDelete = [];
		for( const categ of this.decLinked ) {
			if( !formValue[ categ.id ] ) {

				obssToDelete.push(
					this.documentExchangeService.removeDocumentExchangeCategoryOfMember( this._member.mitgliedId, categ.id ).pipe(
						tap( b => {
							if( b ) {
								const n = this.decLinked.findIndex( c => c.id == categ.id );
								if( n != -1 ) this.decLinked.splice( n, 1 );
							}
						})
					)
				);

			}
		}
		if( obssToDelete.length ) {
			const obsToDelete = forkJoin( obssToDelete ).pipe(
				map( results => {
					for( const result of results ) {
						if( !result ) return false;
					}
					return true;
				} )
			);
			obss.push( obsToDelete );
		}


		const obssToAdd: Observable<boolean>[] = [];
		for( const categId in formValue ) {

			if( !formValue.hasOwnProperty(categId) ) continue;
			if( !formValue[categId] ) continue;
			if( this.decLinked.find( c => c.id == categId ) ) continue;

			obssToAdd.push( this.documentExchangeService.addDocumentExchangeCategoryToMember( this._member.mitgliedId, categId ) );

		}
		if( obssToAdd.length ) {

			obss.push( forkJoin( obssToAdd ).pipe(
				map( results => {

					for( const result of results ) {
						if( !result ) return false;
					}

					this.decLinked = [];
					for( const categId in formValue ) {

						if( !formValue.hasOwnProperty(categId) ) continue;
						if( !formValue[categId] ) continue;
						const categ = this._documentExchangeCategories.find( c => c.id == categId );
						if( categ )	this.decLinked.push( categ );

					}
					return true;

				})
			) );

		}

		this.formDEC.disable( { emitEvent: false } );
		this.bSaveInProgress = true;

		return forkJoin( obss ).pipe(
			map( results => {
				this.formDEC.enable( { emitEvent: false } );
				this.bSaveInProgress = false;

				for( const b of results ) {
					if( !b ) return false;
				}
				return true;
			})
		);

	}

	private saveDateiGruppen(): Observable<boolean> {

		const memberGroups: MemberGroup[] = [];
		for( const groupId in this.formDateiGruppen.controls ) {

			const c = this.formDateiGruppen.get( groupId );
			if( c ) {
				const gr = this.groups.find( o => o.gruppenId == groupId );
				if( gr ) {
					const mg = new MemberGroup();
					mg.gruppenId = groupId;
					mg.mitgliedId = this._member.mitgliedId;
					mg.unassign = !c.value;
					memberGroups.push( mg );
				}
				else {
					console.warn( "GROUP NOT FOUND. BUG?", groupId, this.groups );
					return of(false);
				}
			}
			else {
				console.warn( "CTRL NOT FOUND. BUG?", this.formDateiGruppen, groupId );
				return of(false);
			}

		}
		if( memberGroups.length ) {
			this.formDateiGruppen.disable( { emitEvent: false } );
			return this.fileService.setMemberGroups( memberGroups ).pipe(
				map( result => {
					this.formDateiGruppen.enable( { emitEvent: false } );
					if( result ) this.memberGroupsLinked = result;
					return !!result;
				})
			);
		}
		return of(true);

	}

	private saveMainContact(): Observable<boolean> {

		const newMainContactId = this.mainContactCtrl.value || "";
		this.mainContactCtrl.disable( { emitEvent: false } );

		return this.memberService.setMitgliedMainContact(
			newMainContactId,
			this._member.mitgliedId
		).pipe(
			tap( b => {
				if( b ) {
					this._member.hauptansprechpartnerId = newMainContactId;
				}
				this.mainContactCtrl.disable( { emitEvent: false } );
			} )
		);

	}

	private saveMemberObject(): Observable<Member|null> {

		// Abort autosave when required fields (e.g. mitgliedsnummer) are missing
		if( !this.formG1.valid ) {
			return of(null);
		}

		const elementToSave = { ...new Member(), ...this._member } as Member;
		const f = this.formG1.value;

		for( const fieldname in this.myInputs ) {

			if( f[ fieldname ] === undefined ) continue;
			else {
				(elementToSave[ fieldname as keyof Member ] as any) = f[ fieldname ];
			}

		}

		elementToSave.kategorieIds = [];
		for( const categoryInput of this.categoryInputs ) {
			if( f[ categoryInput.id ] ) {
				const id = categoryInput.id.substring( "category_".length );
				elementToSave.kategorieIds.push( id );
			}
		}

		// opposite because the label says: "Public data?"
		elementToSave.privateDaten = !elementToSave.privateDaten;
		console.log( 'member editor elementToSave', elementToSave )

		if( this._member.mitgliedId && !this.bAdmin ) {
			elementToSave.mitgliedsname = this._member.mitgliedsname;
			elementToSave.mitgliedsnummer = this._member.mitgliedsnummer;
		}

		return this.memberService.saveMember( elementToSave ).pipe(
			tap( memberSaved => {
				if( memberSaved ) {
					for( const property in memberSaved ) {
						this._member[ property ] = memberSaved[ property ];
					}
				}
			} )
		);

	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}

}
